import * as types from '../actions/actionType';

const initialState = {
    apiLoading: {
        isOtaInsightsLoading: true,
        isEventsLoading: true,
    },
};

const propertyReducerByDay = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_OTA_INSIGHTS_DAILY:
            return {
                ...state,
                otaInsights: {
                    date: action.date,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isOtaInsightsLoading: true,
                },
            };
        case types.GET_OTA_INSIGHTS_DAILY_SUCCESS:
            return {
                ...state,
                otaInsights: {
                    ...state.otaInsights,
                    payload: action.payload,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isOtaInsightsLoading: false,
                },
            };
        case types.GET_EVENTS_BY_DAY:
            return {
                ...state,
                events: {
                    startDate: action.startDate,
                    endDate: action.endDate,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isEventsLoading: true,
                },
            };
        case types.GET_EVENTS_BY_DAY_SUCCESS:
            return {
                ...state,
                events: {
                    ...state.events,
                    payload: action.payload,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isEventsLoading: false,
                },
            };
        default:
            return state;
    }
};

export default propertyReducerByDay;
